import { useApiClient, type apiClientErrorType } from '@/services/api-client'
import { useNotificationStore } from '@/store/notifications'
import { errorHandler } from '@/services/api-error-handler'
import { type Router } from 'vue-router'

type RequestMethod = 'GET' | 'PATCH' | 'PUT' | 'POST' | 'DELETE'

interface RequestOptions {
  data?: unknown
  propertyId?: string
}

async function request(
  method: RequestMethod,
  url: string,
  router: Router,
  { data, propertyId }: RequestOptions = {}
) {
  const notificationStore = useNotificationStore()
  try {
    const client = useApiClient(propertyId)
    const response = await client(url, { method, data })
    return response.data
  } catch (error) {
    errorHandler(
      error as apiClientErrorType,
      notificationStore.addNotification,
      router
    )
    throw error
  }
}

function get(url: string, router: Router, propertyId?: string) {
  return request('GET', url, router, { propertyId })
}

function patch(
  url: string,
  data: unknown,
  router: Router,
  propertyId?: string
) {
  return request('PATCH', url, router, { data, propertyId })
}

function put(url: string, data: unknown, router: Router, propertyId?: string) {
  return request('PUT', url, router, { data, propertyId })
}

function post(url: string, data: unknown, router: Router, propertyId?: string) {
  return request('POST', url, router, { data, propertyId })
}

function del(url: string, router: Router, propertyId?: string, data?: unknown) {
  return request('DELETE', url, router, { data, propertyId })
}

export { get, patch, put, post, del }
